import { render, staticRenderFns } from "./im-file-message.vue?vue&type=template&id=3049a7ee&scoped=true"
import script from "./im-file-message.vue?vue&type=script&lang=js"
export * from "./im-file-message.vue?vue&type=script&lang=js"
import style0 from "./im-file-message.vue?vue&type=style&index=0&id=3049a7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049a7ee",
  null
  
)

export default component.exports